import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type DeleteLoreEntryDialogProps = {
  entryTitle: string;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  submitting: boolean;
};

export function DeleteLoreEntryDialog({
  entryTitle,
  onConfirm,
  onOpenChange,
  open,
  submitting,
}: DeleteLoreEntryDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("lore.dialogs.deleteTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("lore.dialogs.deleteBody", { title: entryTitle })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={submitting}>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction disabled={submitting} onClick={onConfirm}>
            {submitting ? t("lore.dialogs.deleting") : t("lore.actions.delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
